const LazyLoad = require("./vanilla-lazyload");
import {PewComponent} from "../../../../themes/wwp_child_theme/assets/raw/js/components/pew-component";

export class LazyLoader extends PewComponent {
    constructor(element, options) {
        let defaultOptions = {

        };

        super(element, Object.assign(defaultOptions, options));
    }

    init() {
        let lazyLoadInstance = new LazyLoad(this.options,this.element);
    }

}

window.pew.addRegistryEntry({key: 'wdf-lazy-loading', domSelector: 'img[data-src]:not(.no-lazy)', classDef: LazyLoader});

